// extracted by mini-css-extract-plugin
export const txtTitle = "reset-module--txtTitle--NfKw0";
export const txtSubTitle = "reset-module--txtSubTitle--UdK7R";
export const input = "reset-module--input--zOxoM";
export const btnReset = "reset-module--btnReset--sgV-t";
export const errorMsg = "reset-module--errorMsg--GKwx4";